// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"581":"9c3c549e","706":"1faa7332"}[chunkId] + ".chunk.css";
};